(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["0-Ruzzur-base"] && !Shopify.designMode) return;
  try {
    
(function(){
  function rzReveal(root){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
    },{threshold:0.12,rootMargin:'0px 0px -8% 0px'});
    root.querySelectorAll('.draw').forEach(function(svg){
      var r=svg.querySelector('rect');
      if(r){ var len=(r.width.baseVal.value+r.height.baseVal.value)*2; svg.style.setProperty('--len',len); }
      io.observe(svg);
    });
    root.querySelectorAll('.reveal').forEach(function(el,i){
      el.style.transitionDelay=(Math.min(i%4,3)*0.07)+'s'; io.observe(el);
    });
  }
  function init(){ document.querySelectorAll('.rz').forEach(function(r){ rzReveal(r); }); }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',init); }
  // Theme-editor friendliness: re-run when a section is added/changed
  document.addEventListener('shopify:section:load',function(e){
    var sec=e.target.querySelector('.rz'); if(sec) rzReveal(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1-Ruzzur-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var originals = new WeakMap();

  function buildMarquee(marquee) {
    var track = marquee.querySelector('.marquee-track');
    if (!track) return;

    var count = parseInt(track.getAttribute('data-count') || '0', 10);
    if (!count) return;

    // 记住最初渲染的 HTML;每次重建都从它开始,避免越克隆越长
    if (!originals.has(track)) originals.set(track, track.innerHTML);
    track.innerHTML = originals.get(track);

    var spans = track.querySelectorAll('span');
    if (spans.length <= count) return;   // 内容不足,保持静态

    // 一组的真实像素宽度 = 第二组首项左缘 − 第一组首项左缘(已含分隔符与间距)
    var period = spans[count].offsetLeft - spans[0].offsetLeft;
    if (!(period > 0)) return;

    // 宽屏补足:克隆"第一组"直到足够长,保证位移一组后画面不留空
    var needed = marquee.clientWidth + period * 2;
    var guard = 0;
    while (track.scrollWidth < needed && guard < 60) {
      for (var k = 0; k < count; k++) {
        track.appendChild(spans[k].cloneNode(true));
      }
      guard++;
    }

    // 写入精确位移量,并重启动画让它立即生效
    track.style.setProperty('--rz-marquee-w', period + 'px');
    track.style.animation = 'none';
    void track.offsetWidth;              // 触发回流
    track.style.animation = '';
  }

  function initAll(root) {
    (root || document).querySelectorAll('.rz .marquee').forEach(buildMarquee);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  // 字体晚加载会改变宽度 → 重测
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { initAll(); });
  }
  window.addEventListener('load', function () { initAll(); });

  // 改变窗口宽度时重建(防抖)
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { initAll(); }, 200);
  });

  // 主题编辑器里增删/重载该 section 时
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
